import { Injectable } from '@angular/core';

export const SIP_CONSTRAINTS = {
  monthlyInvestment: { min: 500, max: 1_000_000, step: 500 },
  rate:              { min: 1,   max: 30,        step: 0.1 },
  tenureYears:       { min: 1,   max: 40,         step: 1 }
} as const;

export interface SipMonthRow {
  month: number;
  invested: number;
  balance: number;
}

export interface SipYearRow {
  year: number;
  invested: number;
  balance: number;
}

export interface SipResult {
  months: SipMonthRow[];
  years: SipYearRow[];
  totalInvested: number;
  totalGain: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class SipCalculatorService {

  calculate(monthlyInvestment: number, annualRate: number, tenureYears: number): SipResult {
    const i = annualRate / 100 / 12;
    const n = tenureYears * 12;

    const months: SipMonthRow[] = [];
    let balance = 0;
    let invested = 0;

    for (let m = 1; m <= n; m++) {
      balance = (balance + monthlyInvestment) * (1 + i);
      invested += monthlyInvestment;
      months.push({ month: m, invested, balance });
    }

    const years: SipYearRow[] = [];
    for (let y = 1; y <= tenureYears; y++) {
      const row = months[y * 12 - 1];
      years.push({ year: y, invested: row.invested, balance: row.balance });
    }

    const totalInvested = monthlyInvestment * n;
    const maturityValue = balance;

    return { months, years, totalInvested, totalGain: maturityValue - totalInvested, maturityValue };
  }
}
